import React from "react";
import { SimpleForm, CreateProps } from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import CreateWrapper from "../../components/CreateWrapper";
import BusScheduleInput from "./components/BusScheduleInput";
import CustomDatePickerInput from "../../components/CustomDatePickerInput";
import moment from "moment/moment";

const DryRunScheduleCreate = (props: CreateProps) => {
  const breadcrumb = [
    { title: "Dry Run Schedules", link: "/dryRunSchedules" },
    { title: "Create", link: "/dryRunSchedules/create" },
  ];

  return (
    <CreateWrapper
      breadcrumb={breadcrumb}
      headerTitle="New Dry Run Schedules"
      isHaveSchoolFilter
      {...props}
    >
      <SimpleForm toolbar={<CustomCreateToolbar />}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">Wave Information</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <BusScheduleInput />
          </Grid>
          <Grid item xs={12} md={8}></Grid>

          <Grid item xs={12} md={4}>
            <CustomDatePickerInput
              name="date"
              label="Select Date *"
              min={moment().add(1, "day").format("Y-MM-DD")}
            />
          </Grid>
          <Grid item xs={12} md={8}></Grid>
        </SanitizedGrid>
      </SimpleForm>
    </CreateWrapper>
  );
};

export default DryRunScheduleCreate;
